import { addDays, differenceInCalendarDays, format, parseISO } from "date-fns";

export const TZ = "America/New_York";

export function todayNY() {
  return new Intl.DateTimeFormat("en-CA", { timeZone: TZ }).format(new Date());
}

export function parseDay(day: string) {
  return parseISO(`${day}T12:00:00`);
}

export function formatDay(day: string, pattern = "MMM d") {
  return format(parseDay(day), pattern);
}

export function nightsBetween(checkIn: string, checkOut: string) {
  return differenceInCalendarDays(parseDay(checkOut), parseDay(checkIn));
}

export function addDaysISO(day: string, amount: number) {
  return format(addDays(parseDay(day), amount), "yyyy-MM-dd");
}

export function isStayExpired(checkOut: string, today = todayNY()) {
  return today >= checkOut;
}

export function isCheckInDayOrAfter(checkIn: string, today = todayNY()) {
  return today >= checkIn;
}

export function rangesOverlap(
  aStart: string,
  aEnd: string,
  bStart: string,
  bEnd: string,
) {
  return aStart < bEnd && bStart < aEnd;
}

export function enumerateDays(start: string, endExclusive: string) {
  const days: string[] = [];
  let cursor = start;
  while (cursor < endExclusive) {
    days.push(cursor);
    cursor = addDaysISO(cursor, 1);
  }
  return days;
}
